import { Component, inject } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Button } from '@app/components/shared/button/button';
import { Providers } from '@app/services/providers/providers';
import { minOneChecked } from '@app/utilities/validators/min-one-cheked';

@Component({
  selector: 'app-upsert-provider-form',
  imports: [Button, ReactiveFormsModule],
  templateUrl: './upsert-form.html',
  styleUrl: './upsert-form.css',
})
export class UpsertProviderForm {
  private readonly FormBuilder = inject(FormBuilder);
  private readonly ProviderService = inject(Providers);
  form!: FormGroup;
  types = [
    { id: '1', label: 'Devolución de calentador en auditoría' },
    { id: '2', label: 'Orden de entrega de calentador' },
    { id: '3', label: 'Garantía de calentador' },
  ];

  constructor() {
    this.buildForm();
  }

  private buildForm() {
    this.form = this.FormBuilder.group({
      name: ['', [Validators.required]],
      nit: ['', [Validators.required, Validators.pattern('^[0-9]+-[0-9]$')]],
      email: ['', [Validators.required, Validators.email]],
      notificationTypes: this.FormBuilder.array(
        this.types.map(() => this.FormBuilder.control(false)),
        { validators: minOneChecked },
      ),
    });
  }

  onCheckboxChange(event: any) {
    if (event.target.checked) {
      this.notificationTypes.push(this.FormBuilder.control(event.target.value));
    } else {
      const index = this.notificationTypes.controls.findIndex(
        (x) => x.value === event.target.value,
      );
      this.notificationTypes.removeAt(index);
    }
  }

  submit() {
    this.form.markAllAsTouched();

    if (this.form.valid) {
      const data = {
        name: this.name.value,
        nit: this.nit.value,
        email: this.email.value,
        notificationTypes: this.types
          .filter((_, index) => this.notificationTypes.value[index])
          .map((type) => type.id),
      };
      this.ProviderService.create(data).subscribe({
        next: (response) => console.log('Provider created', response),
      });
    }
  }

  get notificationTypes() {
    return this.form.get('notificationTypes') as FormArray;
  }

  get name() {
    return this.form.get('name') as FormControl;
  }

  get nit() {
    return this.form.get('nit') as FormControl;
  }

  get email() {
    return this.form.get('email') as FormControl;
  }
}
